import { Button } from "@/components/ui/buttons/button";
import { useSPAContext } from "@/providers/spa-provider";
import { RouteNames } from "@/types/route-names";

export const TrainingPvpModeCard = () => {
  const { setCurrentRoute } = useSPAContext();

  const handleClick = () => {
    setCurrentRoute(RouteNames.DOJO);
  };

  return (
    <Button onClick={handleClick} variant="night" className="w-full">
      <div
        className="opacity-0 shadow-xl p-[4px] rounded-xl flex w-full justify-start transition-colors animate-slide-left-fade duration-300"
        style={{ animationDelay: "125ms" }}
      >
        <div className="relative flex justify-between w-full items-center gap-4 xs:gap-8 px-4 xs:px-8 rounded-md h-14 xs:h-24 overflow-hidden">
          {/* Animated Shine */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform -translate-x-full group-hover:translate-x-full duration-300 ease-in-out" />

          <div className="z-10 relative flex flex-col items-start gap-1">
            <span className="drop-shadow-[3px_3px_0_rgba(0,0,0,0.8)] font-black text-white text-lg xs:text-3xl italic tracking-wider">
              DOJO
            </span>
            <div className="flex items-center gap-2">
              <span className="bg-pk-red-1 px-2 py-0.5 rounded-sm font-bold text-[10px] text-white uppercase tracking-wider">
                SOLO
              </span>
              <span className="font-bold text-pk-gray-4 text-xs xs:text-sm uppercase tracking-widest">
                Training
              </span>
            </div>
          </div>

          <span className="drop-shadow-lg text-2xl xs:text-5xl filter transform">
            🥋
          </span>
        </div>
      </div>
    </Button>
  );
};
